import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uploadFileAction } from "../actions/category";
import { backendImageUrl, RoutesPaths } from "../Router/constant";
import { useLocation, useNavigate } from "react-router-dom";
import { bannerByIdAction, editBannerAction } from "../actions/banner";
import toast from "react-hot-toast";
import ContentLoader from "react-content-loader";
import { allCategories } from "../actions/category";
import { allStores } from "../actions/store";
import Select from "react-select";

export default function EditBanner() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const BannerId = location.pathname?.split("/")[3];
  const { bannerListById } = useSelector((state) => state.banner);
  /* =======================
     STATES
  ======================= */
  const [formData, setFormData] = useState({
    name: {
      en: "",
      pt: "",
    },
    description: {
      en: "",
      pt: "",
    },
    link: "",
  });

  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isimageId, setImageId] = useState();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedTypeId, setSelectedTypeId] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedStoreId, setSelectedStoreId] = useState("");

  const isLoadingData =
    !bannerListById?.data || bannerListById?.data?._id !== BannerId;
  /* =======================
     HANDLERS
  ======================= */

  useEffect(() => {
    dispatch(bannerByIdAction(BannerId));
  }, [BannerId]);
  const [categoryList, setCategories] = useState([]);
  const [storeList, setStores] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await dispatch(allCategories());
      if (res?.status === 200) setCategories(res.data);

      const storeRes = await dispatch(allStores());
      if (storeRes?.status === 200) setStores(storeRes.data);
    };
    fetchData();
  }, [dispatch]);

  /* ======================= PREFILL ======================= */
  useEffect(() => {
    if (bannerListById?.success && bannerListById?.data) {
      const data = bannerListById.data;
      setFormData({
        name: {
          en: data.name?.en || "",
          pt: data.name?.pt || "",
        },
        description: {
          en: data.description?.en || "",
          pt: data.description?.pt || "",
        },
        link: data.link || "",
      });;

      setImagePreview(backendImageUrl + data?.image?.fileName);
      setImageId(data?.image?._id);

      switch (data.type) {
        case "category":
          setSelectedTypeId("1");
          setSelectedCategoryId(
            typeof data.categoryId === "object"
              ? data.categoryId._id
              : data.categoryId || ""
          );
          break;
        case "store":
          setSelectedTypeId("2");
          setSelectedStoreId(
            typeof data.storeId === "object" ? data.storeId._id : data.storeId || ""
          );
          break;
        case "external":
          setSelectedTypeId("3");
          break;
        case "service":
          setSelectedTypeId("4");
          break;
        case "main":
        default:
          setSelectedTypeId("0");
          break;
      }
    }
  }, [bannerListById]);

  /* ======================= HANDLERS ======================= */
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.includes(".")) {
      const [field, lang] = name.split(".");

      setFormData((prev) => {
        const updatedField = {
          ...prev[field],
          [lang]: value,
        };

        const updatedData = {
          ...prev,
          [field]: updatedField,
        };

        // ✅ Remove error ONLY when BOTH filled
        if (field === "name") {
          if (
            updatedField.en.trim() !== "" &&
            updatedField.pt.trim() !== ""
          ) {
            setErrors((prevErr) => ({
              ...prevErr,
              name: "",
            }));
          }
        }

        if (field === "description") {
          if (
            updatedField.en.trim() !== "" &&
            updatedField.pt.trim() !== ""
          ) {
            setErrors((prevErr) => ({
              ...prevErr,
              description: "",
            }));
          }
        }

        return updatedData;
      });
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));

      if (name === "link") {
        setErrors((prev) => ({ ...prev, link: "" }));
      }
    }
  };

  const handleTypeChange = (e) => {
    const value = e.target.value;
    setSelectedTypeId(value);

    setSelectedCategoryId("");
    setSelectedStoreId("");
    setFormData((prev) => ({ ...prev, link: "" }));
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        icon: "Only PNG, JPG, JPEG allowed",
      }));
      return;
    }

    setErrors((prev) => ({ ...prev, icon: "" }));

    const payload = new FormData();
    payload.append("files", file);

    try {
      const response = await dispatch(uploadFileAction(payload));
      if (response?.data) {
        setImageId(response.data.data._id);
        setImagePreview(URL.createObjectURL(file));
      }
    } catch {
      toast.error("Image upload failed");
    }
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
    setImageId(null);
  };

  /* ======================= VALIDATION ======================= */
  const validate = () => {
    let newErrors = {};

    if (!formData.name.en.trim() || !formData.name.pt.trim()) {
      newErrors.name = "Both English and Portuguese names are required";
    }
    if (!imagePreview) newErrors.icon = "Image required";
    if (!selectedTypeId) newErrors.type = "Banner type required";
    if (selectedTypeId === "1" && !selectedCategoryId)
      newErrors.category = "Category required";

    if (selectedTypeId === "2" && !selectedStoreId)
      newErrors.store = "Store required";

    if ((selectedTypeId === "3" || selectedTypeId === "4") && !formData.link)
      newErrors.link = "Link required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getBannerType = () => {
    switch (selectedTypeId) {
      case "0":
        return "main";
      case "1":
        return "category";
      case "2":
        return "store";
      case "3":
        return "external";
      case "4":
        return "service";
      default:
        return "main";
    }
  };
  /* ======================= SUBMIT ======================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    try {
      const type = getBannerType();

      let payload = {
        name: formData.name,
        description: formData.description,
        type,
        image: isimageId,
      };

      if (type === "category") payload.categoryId = selectedCategoryId;
      if (type === "store") payload.storeId = selectedStoreId;
      if (type === "external" || type === "service") payload.link = formData.link;
      const resp = await dispatch(editBannerAction(BannerId, payload));

      if (resp?.data?.success) {
        navigate(RoutesPaths.BANNER);
      }
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const cancelChanges = () => navigate(RoutesPaths.BANNER);

  /* ======================= LOADER ======================= */
  if (isLoadingData) {
    return (
      <div className="container-fluid">
        {[...Array(5)].map((_, i) => (
          <ContentLoader key={i} width="100%" height={50}>
            <rect width="100%" height="50" />
          </ContentLoader>
        ))}
      </div>
    );
  }

  return (
    <>
      {isLoadingData ? (
        <div className="container-fluid contactSkeleton">
          {[...Array(6)].map((_, i) => (
            <ContentLoader key={i} width="100%" height={50}>
              <rect x="0" y="0" rx="5" ry="5" width="100%" height="50" />
            </ContentLoader>
          ))}
        </div>
      ) : (
        <div className="container-fluid mainConatinerSection">
          <form
            className="form d-flex flex-column flex-lg-row"
            onSubmit={handleSubmit}
          >
            {/* LEFT SIDE */}
            <div className="d-flex flex-column gap-7 gap-lg-10 w-100 w-lg-300px mb-7 me-lg-10">
              {/* IMAGE UPLOAD */}
              <div className="card card-flush py-4">
                <div className="card-header">
                  <div className="card-title">
                    <h2 className="required">Thumbnail</h2>
                  </div>
                </div>

                <div className="card-body text-center pt-0">
                  <div
                    className={`image-input image-input-outline mb-3 ${imagePreview
                      ? ""
                      : "image-input-empty image-input-placeholder"
                      }`}
                  >
                    <div
                      className="image-input-wrapper w-150px h-150px"
                      style={{
                        backgroundImage: imagePreview
                          ? `url(${imagePreview})`
                          : "none",
                      }}
                    ></div>

                    <label className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow pencilIconSection">
                      <i className="ki-duotone ki-pencil fs-7">
                        <span className="path1 searchPath"></span>
                        <span className="path2 searchPath"></span>
                      </i>
                      <input
                        type="file"
                        accept=".png,.jpg,.jpeg"
                        hidden
                        onChange={handleImageChange}
                      />
                    </label>

                    {imagePreview && (
                      <span
                        className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow closeIconSection"
                        onClick={handleRemoveImage}
                      >
                        <i className="ki-duotone ki-cross fs-2">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                    )}
                  </div>

                  {errors.icon && (
                    <div className="text-danger fs-7">{errors.icon}</div>
                  )}

                  <div className="text-muted fs-7">
                    Only *.png, *.jpg and *.jpeg image files are accepted
                  </div>
                </div>
              </div>

              {/* STATUS */}
              {/* <div className="card card-flush py-4">
                <div className="card-header">
                  <div className="card-title">
                    <h2>Status</h2>
                  </div>
                </div>

                <div className="card-body pt-0">
                  <select
                    className="form-select"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="published">Published</option>
                    <option value="scheduled">Scheduled</option>
                    <option value="unpublished">Unpublished</option>
                  </select>
                </div>
              </div> */}
            </div>

            {/* RIGHT SIDE */}
            <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
              <div className="card card-flush py-4">
                <div className="card-body pt-0">

                  {/* NAME */}
                  <div className="mb-10">
                    <label className="required form-label">Banner Name (English)</label>
                    <input
                      type="text"
                      name="name.en"
                      className="form-control mb-2"
                      value={formData.name.en}
                      onChange={handleChange}
                    />

                    <label className="required form-label mt-3">Banner Name (Portuguese)</label>
                    <input
                      type="text"
                      name="name.pt"
                      className="form-control"
                      value={formData.name.pt}
                      onChange={handleChange}
                    />

                    {errors.name && <p className="text-danger">{errors.name}</p>}
                  </div>

                  {/* DESCRIPTION */}
                  <div className="mb-10">
                    <label className="form-label">Description (English)</label>
                    <textarea
                      name="description.en"
                      className="form-control mb-2"
                      value={formData.description.en}
                      onChange={handleChange}
                    />

                    <label className="form-label mt-3">Description (Portuguese)</label>
                    <textarea
                      name="description.pt"
                      className="form-control"
                      value={formData.description.pt}
                      onChange={handleChange}
                    />
                  </div>

                  {/* TYPE */}
                  <div className="mb-10">
                    <label className="required form-label">Select type</label>
                    <Select
                      placeholder="Select a type"
                      value={[
                        { value: "0", label: "Main" },
                        { value: "1", label: "Category" },
                        { value: "2", label: "Store" },
                        { value: "3", label: "External" },
                      ].find(opt => opt.value === selectedTypeId)}

                      options={[
                        { value: "0", label: "Main" },
                        { value: "1", label: "Category" },
                        { value: "2", label: "Store" },
                        { value: "3", label: "External" },
                      ]}

                      onChange={(selected) =>
                        handleTypeChange({ target: { value: selected.value } })
                      }
                    />
                  </div>

                  {/* CATEGORY */}
                  {selectedTypeId === "1" && (
                    <div className="mb-3">
                      <label className="required form-label">Category</label>
                      <Select
                        placeholder="Select a category"
                        value={categoryList?.data
                          ?.map(item => ({
                            value: item._id,
                            label: item.name
                          }))
                          .find(opt => opt.value === selectedCategoryId)
                        }
                        options={categoryList?.data?.map(item => ({
                          value: item._id,
                          label: item.name
                        }))}
                        onChange={(selectedOption) =>
                          setSelectedCategoryId(selectedOption ? selectedOption.value : "")
                        }
                      />
                      {errors.category && <p className="text-danger">{errors.category}</p>}
                    </div>
                  )}

                  {/* STORE */}
                  {selectedTypeId === "2" && (
                    <div className="mb-3">
                      <label className="required form-label">Store</label>
                      <Select
                        placeholder="Select a store"
                        value={storeList?.data
                          ?.map(item => ({
                            value: item._id,
                            label: item.shopName
                          }))
                          .find(opt => opt.value === selectedStoreId)
                        }
                        options={storeList?.data?.map(item => ({
                          value: item._id,
                          label: item.shopName
                        }))}
                        onChange={(selectedOption) =>
                          setSelectedStoreId(selectedOption ? selectedOption.value : "")
                        }
                      />
                      {errors.store && <p className="text-danger">{errors.store}</p>}
                    </div>
                  )}

                  {/* LINK */}
                  {selectedTypeId === "3" && (
                    <div className="mb-3">
                      <label className="required form-label">External Link</label>
                      <input
                        className="form-control"
                        name="link"
                        value={formData.link}
                        onChange={handleChange}
                      />
                      {errors.link && <p className="text-danger">{errors.link}</p>}
                    </div>
                  )}
                </div>
              </div>

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-light me-5"
                  onClick={cancelChanges}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="btn buttonPrimary"
                >
                  {loading ? "Please wait..." : "Update Banner"}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
